module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anat Plocker\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Anat Plocker teaches at the School of General Studies at Stockton University, specializing in Modern European History. Her work on communist Poland has appeared in English, Polish and Hebrew.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TPw4Zb/tc-custom/9780253058638.jpg?1731806706840",
      "alt": "This image is the cover for the book Expulsion of Jews from Communist Poland, The Modern Jewish Experience"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Expulsion of Jews from Communist Poland, The Modern Jewish Experience\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In March 1968, against the background of the Six-Day War, a campaign of antisemitism and anti-Zionism swept through Poland. "), _c('i', [_vm._v("The Expulsion of Jews from Communist Poland")]), _vm._v(" is the first full-length study of the events, their precursors, and the aftermath of this turbulent period. ")]), _c('p', [_vm._v("Plocker offers a new framework for understanding how this antisemitic campaign was motivated by a genuine fear of Jewish influence and international power. She sheds new light on the internal dynamics of the communist regime in Poland, stressing the importance of middle-level functionaries, whose dislike and fear of Jews had an unmistakable impact on the evolution of party policy.")]), _c('p', [_c('i', [_vm._v("The Expulsion of Jews from Communist Poland")]), _vm._v(" examines how Communist Party leader Wladyslaw Gomulka's anti-Zionist rhetoric spiraled out of hand and opened up a fraught Pandora's box of old assertions that Jews controlled the Communist Party, the revival of nationalist chauvinism, and a witch hunt in universities and workplaces that conjured up ugly memories of Nazi Germany.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0